/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCellphoneWireless: {
  name: 'cellphone-wireless';
  data: string;
} = {
  name: 'cellphone-wireless',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1a1 1 0 1 1-2 0V6H8v12h8v-1a1 1 0 1 1 2 0v1a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6Zm9 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1-4a1 1 0 1 0 0 2 2 2 0 1 1 0 4 1 1 0 1 0 0 2 4 4 0 0 0 0-8Z" fill="currentColor"/></svg>`,
};
